/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ActivityLogView,
    ActivityLogViewFromJSON,
    ActivityLogViewToJSON,
    BDOperation,
    BDOperationFromJSON,
    BDOperationToJSON,
    EntityType,
    EntityTypeFromJSON,
    EntityTypeToJSON,
} from '../models';

export interface UpdateHistoryActivitylogGetRequest {
    dayOffset?: number;
}

export interface UpdateHistoryHistoryGetRequest {
    id?: string;
    type?: EntityType;
}

export interface UpdateHistoryRawRecordsGetRequest {
    startDate?: Date;
    endDate?: Date;
}

/**
 * no description
 */
export class UpdateHistoryApi extends runtime.BaseAPI {

    /**
     */
    async updateHistoryActivitylogGetRaw(requestParameters: UpdateHistoryActivitylogGetRequest): Promise<runtime.ApiResponse<Array<ActivityLogView>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.dayOffset !== undefined) {
            queryParameters['dayOffset'] = requestParameters.dayOffset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/UpdateHistory/activitylog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivityLogViewFromJSON));
    }

    /**
     */
    async updateHistoryActivitylogGet(requestParameters: UpdateHistoryActivitylogGetRequest): Promise<Array<ActivityLogView>> {
        const response = await this.updateHistoryActivitylogGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateHistoryHistoryGetRaw(requestParameters: UpdateHistoryHistoryGetRequest): Promise<runtime.ApiResponse<Array<BDOperation>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/UpdateHistory/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BDOperationFromJSON));
    }

    /**
     */
    async updateHistoryHistoryGet(requestParameters: UpdateHistoryHistoryGetRequest): Promise<Array<BDOperation>> {
        const response = await this.updateHistoryHistoryGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateHistoryRawRecordsGetRaw(requestParameters: UpdateHistoryRawRecordsGetRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/UpdateHistory/raw-records`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async updateHistoryRawRecordsGet(requestParameters: UpdateHistoryRawRecordsGetRequest): Promise<string> {
        const response = await this.updateHistoryRawRecordsGetRaw(requestParameters);
        return await response.value();
    }

}
